// Data Kalender Jawa & Pranata Mangsa

export const HARI = ["Minggu","Senin","Selasa","Rabu","Kamis","Jumat","Sabtu"];
export const NEPTU_HARI = [5,4,3,7,8,6,9];
export const PASARAN = ["Legi","Pahing","Pon","Wage","Kliwon"];
export const NEPTU_PASARAN = [5,9,7,4,8];
export const BULAN_MASEHI = ["Januari","Februari","Maret","April","Mei","Juni","Juli","Agustus","September","Oktober","November","Desember"];
export const BULAN_JAWA = ["Sura","Sapar","Mulud","Bakda Mulud","Jumadilawal","Jumadilakhir","Rejeb","Ruwah","Pasa","Sawal","Dulkangidah","Besar"];
export const WINDU = ["Alip","Ehe","Jimawal","Je","Dal","Be","Wawu","Jimakir"];

export const WUKU = [
  "Sinta","Landep","Wukir","Kurantil","Tolu","Gumbreg","Warigalit","Warigagung",
  "Julungwangi","Sungsang","Galungan","Kuningan","Langkir","Mandasiya","Julungpujut","Pahang",
  "Kuruwelut","Marakeh","Tambir","Medangkungan","Maktal","Wuye","Manahil","Prangbakat","Bala",
  "Wugu","Wayang","Kulawu","Dukut","Watugunung"
];

export const DUNUNGE = [
  "Lor Wetan","Kulon","Kidul Wetan","Ngisor","Lor Kulon","Kidul Wetan","Duwur","Lor","Kidul Kulon","Wetan",
  "Lor Wetan","Kulon","Kidul Wetan","Ngisor","Lor Kulon","Kidul","Duwur","Lor","Kidul Kulon","Wetan",
  "Lor Wetan","Kulon","Kidul Wetan","Ngisor","Lor Kulon","Kidul","Duwur","Lor","Kidul Kulon","Wetan"
];

export const GRID = [
  [["PS","R",0],["RAT","R",0],["S","R",1],["NS","R",0],["","G",0],["","G",0],["P","R",0]],
  [["RT","R",1],["","G",0],["N","G",0],["WQ","R",0],["","G",0],["P","R",0],["R","R",1]],
  [["","G",0],["N","G",0],["","G",0],["","G",0],["I","G",0],["R","R",1],["","G",0]],
  [["N","R",0],["","G",1],["OP","G",0],["XT","R",0],["R","R",0],["","G",0],["N","R",0]],
  [["","G",1],["P","G",0],["I","G",0],["R","R",1],["P","R",0],["I","G",0],["","G",0]],
  [["P","R",0],["T","G",0],["R","R",1],["N","R",0],["","G",0],["","G",0],["P","R",0]],
  [["T","R",0],["RA","G",0],["N","G",0],["Q","R",0],["W","G",0],["P","R",0],["","G",1]],
  [["RK","G",0],["N","G",0],["","G",0],["","G",0],["I","R",0],["S","G",1],["RS","G",0]],
  [["N","R",0],["","R",1],["OP","R",0],["I","R",0],["","G",0],["R","R",0],["N","R",0]],
  [["","G",1],["P","R",0],["T","R",0],["S","R",0],["RP","R",0],["T","R",0],["","G",0]],
  [["DP","R",0],["DT","R",0],["D","R",1],["XRN","R",0],["","G",0],["","G",0],["P","R",0]],
  [["I","R",1],["","G",0],["RN","R",0],["Q","R",1],["","G",0],["PW","R",0],["S","R",1]],
  [["","G",0],["RAN","R",0],["","G",0],["","G",0],["T","G",0],["","G",1],["","G",0]],
  [["RN","R",0],["","G",1],["OP","R",0],["I","R",0],["","G",0],["","G",0],["RN","R",0]],
  [["","G",1],["P","G",0],["I","R",0],["","G",1],["P","R",0],["RT","R",0],["","G",1]],
  [["P","R",0],["T","R",0],["","G",1],["N","R",0],["R","R",1],["","G",0],["P","R",0]],
  [["KI","R",0],["","G",0],["N","R",0],["RQ","R",1],["","G",0],["P","R",0],["W","R",1]],
  [["","G",0],["N","R",0],["R","G",1],["X","R",0],["I","R",0],["","G",1],["","G",0]],
  [["N","R",0],["RA","R",1],["OP","R",0],["T","R",0],["","G",0],["","R",0],["N","R",0]],
  [["R","R",1],["P","R",0],["I","R",0],["","G",0],["P","R",0],["I","R",0],["R","R",1]],
  [["P","R",0],["I","R",0],["","G",1],["N","R",0],["","G",0],["R","R",0],["","R",0]],
  [["T","R",0],["W","R",0],["N","R",0],["Q","R",1],["R","R",0],["P","R",0],["","G",1]],
  [["","G",0],["N","G",0],["","G",0],["R","R",0],["I","R",0],["","G",1],["","G",0]],
  [["N","R",0],["","G",1],["ROP","R",0],["I","R",0],["","G",0],["","G",0],["N","R",0]],
  [["","G",1],["RAP","R",0],["T","R",0],["X","R",1],["P","R",0],["T","R",0],["","G",0]],
  [["PRK","R",0],["I","R",0],["","G",1],["N","R",0],["","G",1],["","G",0],["RP","R",0]],
  [["I","R",0],["","G",0],["NW","R",0],["Q","R",1],["S","R",0],["RP","R",0],["","G",1]],
  [["","G",0],["N","G",0],["","G",0],["","G",0],["RT","R",0],["","G",1],["","G",0]],
  [["N","R",0],["","G",1],["OP","R",0],["RT","R",0],["","G",0],["","G",0],["N","R",0]],
  [["","G",1],["P","R",0],["RT","R",0],["","G",1],["P","R",0],["I","R",0],["","G",0]]
];

export const KETERANGAN = [
  ["S","Tangise Dewi Sinto"],["O","Anggoro Kasih"],["W","Tali Wangke"],["N","Nuju Padu"],
  ["Q","Dino ora kanggonan tanggal"],["R","Ringkel Jalma"],["K","Kala Dite"],["T","Kala Tinantang"],
  ["P","Nuju Pati"],["D","Dungulan"],["A","Sampar Wangke"],["X","Sarik Agung"]
];

// Julian Day Number helpers
export function toJDN(y, m, d) {
  const a = Math.floor((14 - m) / 12);
  const y2 = y + 4800 - a;
  const m2 = m + 12 * a - 3;
  return d + Math.floor((153 * m2 + 2) / 5) + 365 * y2 + Math.floor(y2 / 4) - Math.floor(y2 / 100) + Math.floor(y2 / 400) - 32045;
}

const ISLAMIC_EPOCH = 1948440;

export function jdnToIslamic(jdn) {
  jdn = Math.floor(jdn);
  const n = jdn - ISLAMIC_EPOCH + 10632;
  const cyc = Math.floor(n / 10631);
  const rem0 = n % 10631 + 354;
  const j = Math.floor((10985 - rem0) / 5316) * Math.floor((50 * rem0) / 17719) + Math.floor(rem0 / 5670) * Math.floor((43 * rem0) / 15238);
  const rem2 = rem0 - Math.floor((30 - j) / 15) * Math.floor((17719 * j) / 50) - Math.floor(j / 16) * Math.floor((15238 * j) / 43) + 29;
  const m = Math.floor((24 * rem2) / 709);
  const d = rem2 - Math.floor((709 * m) / 24);
  const y = 30 * cyc + j - 30;
  return [y, m, d];
}

// Epoch Patokan Abadi Kalender Jawa & Pawukon:
// JDN 2459456 = 29 Agustus 2021 (Minggu Pahing, Wuku Sinta - Hari ke-0 dari Siklus Pawukon 210 Hari)
export const EPOCH_JDN = 2459456;
const JDN_LEGI_ANCHOR = 2459590; // toJDN(2022, 1, 10) - Senin Legi
const SUN_JDN_ANCHOR = 2459589;  // toJDN(2022, 1, 9)  - Minggu wuku Madangkungan (idx 19)
const WUKU_ANCHOR_IDX = 19;

// Cache O(1) instan untuk hasil perhitungan per tanggal
const DAY_INFO_CACHE = Object.create(null);

export function getDayInfo(y, m, d) {
  const key = y * 10000 + m * 100 + d;
  if (DAY_INFO_CACHE[key]) return DAY_INFO_CACHE[key];

  const jdn = toJDN(y, m, d);
  const diffDays = jdn - EPOCH_JDN;
  const weekdayId = ((diffDays % 7) + 7) % 7; // 0 = Minggu, 1 = Senin, ... 6 = Sabtu
  const pasaranId = (((diffDays + 1) % 5) + 5) % 5; // 0 = Legi, 1 = Pahing, 2 = Pon, 3 = Wage, 4 = Kliwon
  const pDay = ((diffDays % 210) + 210) % 210;
  const wukuId = Math.floor(pDay / 7); // 0 = Sinta ... 29 = Watugunung
  const [hy, hm, hd] = jdnToIslamic(jdn);
  const ajYear = hy + 512;

  const result = { jdn, weekdayId, pasaranId, wukuId, hijri: [hd, hm, hy], ajYear };
  DAY_INFO_CACHE[key] = result;
  return result;
}

export function getTanggalJawaLengkap(y, m, d) {
  const info = getDayInfo(y, m, d);
  const dino = HARI[info.weekdayId];
  const pas = PASARAN[info.pasaranId];
  const neptu = NEPTU_HARI[info.weekdayId] + NEPTU_PASARAN[info.pasaranId];
  const wukuName = WUKU[info.wukuId];
  const wukuNo = info.wukuId + 1;

  const tglJawa = info.hijri[0];
  const bulanJawa = BULAN_JAWA[info.hijri[1] - 1] || "-";
  const tahunAJ = info.ajYear;
  
  const TAHUN_SIKLUS_8 = ["Alip", "Ehe", "Jimawal", "Je", "Dal", "Be", "Wawu", "Jimakir"];
  const tahunSiklus = TAHUN_SIKLUS_8[((tahunAJ - 1955) % 8 + 8) % 8];
  
  const WINDU_4 = ["Kuntara (Adi)", "Sangara", "Sancaya", "Buntara (Pangsa)"];
  const winduIndex = ((Math.floor((tahunAJ - 1955) / 8) % 4) + 4) % 4;
  const namaWindu = WINDU_4[winduIndex];

  const fullStr = `${tglJawa} ${bulanJawa} ${tahunAJ} AJ (Tahun ${tahunSiklus}, Windu ${namaWindu})`;
  const shortStr = `${tglJawa} ${bulanJawa} ${tahunAJ} AJ`;

  return {
    tglJawa,
    bulanJawa,
    tahunAJ,
    tahunSiklus,
    namaWindu,
    dino,
    pas,
    neptu,
    wukuName,
    wukuNo,
    fullStr,
    shortStr
  };
}

export const LIBUR_NASIONAL = {
  fixed: {
    "1-1": "Tahun Baru Masehi",
    "5-1": "Hari Buruh Internasional",
    "6-1": "Hari Lahir Pancasila",
    "8-17": "Hari Proklamasi Kemerdekaan RI",
    "12-25": "Hari Raya Natal"
  },
  custom: {
    // 2024
    "2024-1-1": "Tahun Baru 2024 Masehi",
    "2024-2-8": "Isra Mi'raj Nabi Muhammad SAW",
    "2024-2-10": "Tahun Baru Imlek 2575 Kongzili",
    "2024-3-11": "Hari Suci Nyepi Tahun Baru Saka 1946",
    "2024-3-29": "Wafat Yesus Kristus (Jumat Agung)",
    "2024-3-31": "Hari Paskah",
    "2024-4-10": "Hari Raya Idul Fitri 1445 H",
    "2024-4-11": "Hari Raya Idul Fitri 1445 H",
    "2024-5-1": "Hari Buruh Internasional",
    "2024-5-9": "Kenaikan Yesus Kristus",
    "2024-5-23": "Hari Raya Waisak 2568 BE",
    "2024-6-1": "Hari Lahir Pancasila",
    "2024-6-17": "Hari Raya Idul Adha 1445 H",
    "2024-7-7": "Tahun Baru Islam 1446 H (1 Sura)",
    "2024-8-17": "Hari Kemerdekaan RI Ke-79",
    "2024-9-16": "Maulid Nabi Muhammad SAW",
    "2024-12-25": "Hari Raya Natal",

    // 2025
    "2025-1-1": "Tahun Baru 2025 Masehi",
    "2025-1-27": "Isra Mi'raj Nabi Muhammad SAW",
    "2025-1-29": "Tahun Baru Imlek 2576 Kongzili",
    "2025-3-29": "Hari Suci Nyepi Tahun Baru Saka 1947",
    "2025-3-31": "Hari Raya Idul Fitri 1446 H",
    "2025-4-1": "Hari Raya Idul Fitri 1446 H",
    "2025-4-18": "Wafat Yesus Kristus",
    "2025-4-20": "Hari Paskah",
    "2025-5-1": "Hari Buruh Internasional",
    "2025-5-12": "Hari Raya Waisak 2569 BE",
    "2025-5-29": "Kenaikan Yesus Kristus",
    "2025-6-1": "Hari Lahir Pancasila",
    "2025-6-7": "Hari Raya Idul Adha 1446 H",
    "2025-6-27": "Tahun Baru Islam 1447 H (1 Sura)",
    "2025-8-17": "Hari Kemerdekaan RI Ke-80",
    "2025-9-5": "Maulid Nabi Muhammad SAW",
    "2025-12-25": "Hari Raya Natal",

    // 2026
    "2026-1-1": "Tahun Baru 2026 Masehi",
    "2026-1-16": "Isra Mi'raj Nabi Muhammad SAW",
    "2026-2-17": "Tahun Baru Imlek 2577 Kongzili",
    "2026-3-19": "Hari Suci Nyepi Tahun Baru Saka 1948",
    "2026-3-20": "Hari Raya Idul Fitri 1447 H",
    "2026-3-21": "Hari Raya Idul Fitri 1447 H",
    "2026-4-3": "Wafat Yesus Kristus",
    "2026-4-5": "Hari Paskah",
    "2026-5-1": "Hari Buruh Internasional",
    "2026-5-14": "Kenaikan Yesus Kristus",
    "2026-5-27": "Hari Raya Idul Adha 1447 H",
    "2026-5-31": "Hari Raya Waisak 2570 BE",
    "2026-6-1": "Hari Lahir Pancasila",
    "2026-6-16": "Tahun Baru Islam 1448 H (1 Sura)",
    "2026-8-17": "Hari Kemerdekaan RI Ke-81",
    "2026-8-25": "Maulid Nabi Muhammad SAW",
    "2026-12-25": "Hari Raya Natal",

    // 2027
    "2027-1-1": "Tahun Baru 2027 Masehi",
    "2027-1-6": "Isra Mi'raj Nabi Muhammad SAW",
    "2027-2-6": "Tahun Baru Imlek 2578 Kongzili",
    "2027-3-9": "Hari Raya Idul Fitri 1448 H",
    "2027-3-10": "Hari Raya Idul Fitri 1448 H",
    "2027-3-26": "Wafat Yesus Kristus",
    "2027-3-28": "Hari Paskah",
    "2027-4-8": "Hari Suci Nyepi Tahun Baru Saka 1949",
    "2027-5-1": "Hari Buruh Internasional",
    "2027-5-6": "Kenaikan Yesus Kristus",
    "2027-5-16": "Hari Raya Idul Adha 1448 H",
    "2027-5-20": "Hari Raya Waisak 2571 BE",
    "2027-6-1": "Hari Lahir Pancasila",
    "2027-6-6": "Tahun Baru Islam 1449 H (1 Sura)",
    "2027-8-15": "Maulid Nabi Muhammad SAW",
    "2027-8-17": "Hari Kemerdekaan RI Ke-82",
    "2027-12-25": "Hari Raya Natal",

    // 2028
    "2028-1-1": "Tahun Baru 2028 Masehi",
    "2028-1-26": "Tahun Baru Imlek 2579 Kongzili",
    "2028-2-24": "Isra Mi'raj Nabi Muhammad SAW",
    "2028-2-27": "Hari Raya Idul Fitri 1449 H",
    "2028-2-28": "Hari Raya Idul Fitri 1449 H",
    "2028-3-26": "Hari Suci Nyepi Tahun Baru Saka 1950",
    "2028-4-14": "Wafat Yesus Kristus",
    "2028-4-16": "Hari Paskah",
    "2028-5-1": "Hari Buruh Internasional",
    "2028-5-5": "Hari Raya Idul Adha 1449 H",
    "2028-5-9": "Hari Raya Waisak 2572 BE",
    "2028-5-25": "Kenaikan Yesus Kristus",
    "2028-5-26": "Tahun Baru Islam 1450 H (1 Sura)",
    "2028-6-1": "Hari Lahir Pancasila",
    "2028-8-4": "Maulid Nabi Muhammad SAW",
    "2028-8-17": "Hari Kemerdekaan RI Ke-83",
    "2028-12-25": "Hari Raya Natal"
  }
};

// Flat lookup table O(1) untuk libur nasional
const LIBUR_FLAT = Object.assign(Object.create(null), LIBUR_NASIONAL.custom, LIBUR_NASIONAL.fixed);

export function getLiburNasional(y, m, d) {
  return LIBUR_FLAT[`${y}-${m}-${d}`] || LIBUR_FLAT[`${m}-${d}`] || null;
}

// Basis Data Resmi Dino Gede & Dino Ijo dari database_nujum CSV
export const DINO_GEDE_LIST = [
  ["Selasa","Wage","Sinta"],["Kamis","Legi","Sinta"],["Jumat","Pahing","Sinta"],
  ["Rabu","Pahing","Landep"],["Sabtu","Kliwon","Landep"],["Selasa","Pon","Wukir"],
  ["Jumat","Legi","Wukir"],["Senin","Wage","Kurantil"],["Kamis","Pahing","Kurantil"],
  ["Minggu","Kliwon","Tolu"],["Rabu","Pon","Tolu"],["Sabtu","Legi","Tolu"],
  ["Selasa","Wage","Gumbreg"],["Kamis","Legi","Gumbreg"],["Jumat","Pahing","Gumbreg"],
  ["Rabu","Pahing","Warigalit"],["Sabtu","Kliwon","Warigalit"],["Selasa","Pon","Warigagung"],
  ["Jumat","Legi","Warigagung"],["Senin","Wage","Julungwangi"],["Kamis","Pahing","Julungwangi"],
  ["Minggu","Kliwon","Sungsang"],["Rabu","Pon","Sungsang"],["Sabtu","Legi","Sungsang"],
  ["Selasa","Wage","Galungan"],["Kamis","Legi","Galungan"],["Jumat","Pahing","Galungan"],
  ["Rabu","Pahing","Kuningan"],["Sabtu","Kliwon","Kuningan"],["Selasa","Pon","Langkir"],
  ["Jumat","Legi","Langkir"],["Senin","Wage","Mandasiya"],["Kamis","Pahing","Mandasiya"],
  ["Minggu","Kliwon","Julungpujut"],["Rabu","Pon","Julungpujut"],["Sabtu","Legi","Julungpujut"],
  ["Selasa","Wage","Pahang"],["Kamis","Legi","Pahang"],["Jumat","Pahing","Pahang"],
  ["Rabu","Pahing","Kuruwelut"],["Sabtu","Kliwon","Kuruwelut"],["Selasa","Pon","Marakeh"],
  ["Jumat","Legi","Marakeh"],["Senin","Wage","Tambir"],["Kamis","Pahing","Tambir"],
  ["Minggu","Kliwon","Medangkungan"],["Rabu","Pon","Medangkungan"],["Sabtu","Legi","Medangkungan"],
  ["Selasa","Wage","Maktal"],["Kamis","Legi","Maktal"],["Jumat","Pahing","Maktal"],
  ["Rabu","Pahing","Wuye"],["Sabtu","Kliwon","Wuye"],["Selasa","Pon","Manahil"],["Jumat","Legi","Manahil"],
  ["Senin","Wage","Prangbakat"],["Kamis","Pahing","Prangbakat"],["Minggu","Kliwon","Bala"],
  ["Rabu","Pon","Bala"],["Sabtu","Legi","Bala"],["Selasa","Wage","Wugu"],
  ["Kamis","Legi","Wugu"],["Jumat","Pahing","Wugu"],["Rabu","Pahing","Wayang"],
  ["Sabtu","Kliwon","Wayang"],["Selasa","Pon","Kulawu"],["Jumat","Legi","Kulawu"],
  ["Senin","Wage","Dukut"],["Kamis","Pahing","Dukut"],["Minggu","Kliwon","Watugunung"],
  ["Rabu","Pon","Watugunung"],["Sabtu","Legi","Watugunung"]
];

export const DINO_IJO_LIST = [
  ["Kamis","Legi","Sinta"],["Jumat","Pahing","Sinta"],["Senin","Kliwon","Landep"],
  ["Kamis","Pon","Landep"],["Minggu","Legi","Wukir"],["Selasa","Pon","Wukir"],
  ["Rabu","Wage","Wukir"],["Sabtu","Pahing","Wukir"],["Senin","Wage","Kurantil"],
  ["Jumat","Pon","Kurantil"],["Minggu","Kliwon","Tolu"],["Sabtu","Legi","Tolu"],
  ["Kamis","Legi","Gumbreg"],["Jumat","Pahing","Gumbreg"],["Sabtu","Kliwon","Warigalit"],
  ["Selasa","Pon","Warigagung"],["Rabu","Wage","Warigagung"],["Senin","Wage","Julungwangi"],
  ["Kamis","Pahing","Julungwangi"],["Minggu","Kliwon","Sungsang"],["Sabtu","Legi","Sungsang"],
  ["Kamis","Legi","Galungan"],["Jumat","Pahing","Galungan"],["Senin","Kliwon","Kuningan"],
  ["Kamis","Pon","Kuningan"],["Minggu","Legi","Langkir"],["Selasa","Pon","Langkir"],
  ["Rabu","Wage","Langkir"],["Jumat","Legi","Langkir"],["Sabtu","Pahing","Langkir"],
  ["Senin","Wage","Mandasiya"],["Kamis","Pahing","Mandasiya"],["Jumat","Pon","Mandasiya"],
  ["Minggu","Kliwon","Julungpujut"],["Rabu","Pon","Julungpujut"],["Sabtu","Legi","Julungpujut"],
  ["Selasa","Wage","Pahang"],["Jumat","Pahing","Pahang"],["Senin","Kliwon","Kuruwelut"],
  ["Kamis","Pon","Kuruwelut"],["Minggu","Legi","Marakeh"],["Jumat","Legi","Marakeh"],
  ["Sabtu","Pahing","Marakeh"],["Kamis","Pahing","Tambir"],["Jumat","Pon","Tambir"],
  ["Rabu","Pon","Medangkungan"],["Selasa","Wage","Maktal"],["Kamis","Legi","Maktal"],
  ["Sabtu","Kliwon","Wuye"],["Minggu","Legi","Manahil"],["Selasa","Pon","Manahil"],
  ["Jumat","Legi","Manahil"],["Sabtu","Pahing","Manahil"],["Senin","Wage","Prangbakat"],
  ["Kamis","Pahing","Prangbakat"],["Jumat","Pon","Prangbakat"],["Minggu","Kliwon","Bala"],
  ["Sabtu","Legi","Bala"],["Selasa","Wage","Wugu"],["Kamis","Legi","Wugu"],
  ["Jumat","Pahing","Wugu"],["Senin","Kliwon","Wayang"],["Sabtu","Kliwon","Wayang"],
  ["Minggu","Legi","Kulawu"],["Selasa","Pon","Kulawu"],["Rabu","Wage","Kulawu"],
  ["Jumat","Legi","Kulawu"],["Sabtu","Pahing","Kulawu"],["Senin","Wage","Dukut"],
  ["Kamis","Pahing","Dukut"],["Jumat","Pon","Dukut"],["Minggu","Kliwon","Watugunung"],
  ["Rabu","Pon","Watugunung"],["Sabtu","Legi","Watugunung"]
];

const HARI_NAMES_CAL = new Set(['minggu', 'senin', 'selasa', 'rabu', 'kamis', 'jumat', 'sabtu']);
const PASARAN_NAMES_CAL = new Set(['legi', 'pahing', 'pon', 'wage', 'kliwon']);

export function parseDinoWukuArgs(a, b, c) {
  let dino = '', pasaran = '', wuku = '';
  if (typeof a === 'object' && a !== null) {
    dino = a.dino || a.hari || '';
    pasaran = a.pasaran || a.pas || '';
    wuku = a.wuku || a.wukuName || '';
  } else if (typeof a === 'string' && (b === undefined || b === null || b === '')) {
    const parts = a.split(/[\s_\-]+/);
    if (parts.length === 3) {
      return parseDinoWukuArgs(parts[0], parts[1], parts[2]);
    }
  } else {
    const args = [String(a || '').trim(), String(b || '').trim(), String(c || '').trim()];
    for (const arg of args) {
      const lower = arg.toLowerCase();
      if (!dino && HARI_NAMES_CAL.has(lower)) {
        dino = arg;
      } else if (!pasaran && PASARAN_NAMES_CAL.has(lower)) {
        pasaran = arg;
      } else if (!wuku) {
        wuku = arg;
      }
    }
    if (!wuku && args[2]) wuku = args[2];
    if (!dino && args[0]) dino = args[0];
    if (!pasaran && args[1]) pasaran = args[1];
  }
  return {
    dino: dino.trim(),
    pasaran: pasaran.trim(),
    wuku: wuku.trim().replace(/[\s\-_]/g, '')
  };
}

export function normDinoWukuKey(a, b, c) {
  const { dino, pasaran, wuku } = parseDinoWukuArgs(a, b, c);
  const d = dino.toLowerCase();
  const p = pasaran.toLowerCase();
  const w = wuku.toLowerCase()
    .replace(/^shinto$/, 'sinta')
    .replace(/^sinto$/, 'sinta')
    .replace(/^wariagung$/, 'warigagung')
    .replace(/^madangkungan$/, 'medangkungan')
    .replace(/^mendangkungan$/, 'medangkungan')
    .replace(/^manail$/, 'manahil')
    .replace(/^watugunung$/, 'watugunung')
    .replace(/^julungwangi$/, 'julungwangi')
    .replace(/^julungpujut$/, 'julungpujut');
  return `${w}_${d}_${p}`;
}

export const DINO_GEDE_SET = new Set();
DINO_GEDE_LIST.forEach(([d, p, w]) => {
  DINO_GEDE_SET.add(normDinoWukuKey(w, d, p));
  DINO_GEDE_SET.add(normDinoWukuKey(d, p, w));
  DINO_GEDE_SET.add(`${String(d).toLowerCase()}_${String(p).toLowerCase()}_${String(w).toLowerCase().replace(/[\s\-_]/g, '')}`);
  DINO_GEDE_SET.add(`${String(w).toLowerCase().replace(/[\s\-_]/g, '')}_${String(d).toLowerCase()}_${String(p).toLowerCase()}`);
});

export const DINO_IJO_SET = new Set();
DINO_IJO_LIST.forEach(([d, p, w]) => {
  DINO_IJO_SET.add(normDinoWukuKey(w, d, p));
  DINO_IJO_SET.add(normDinoWukuKey(d, p, w));
  DINO_IJO_SET.add(`${String(d).toLowerCase()}_${String(p).toLowerCase()}_${String(w).toLowerCase().replace(/[\s\-_]/g, '')}`);
  DINO_IJO_SET.add(`${String(w).toLowerCase().replace(/[\s\-_]/g, '')}_${String(d).toLowerCase()}_${String(p).toLowerCase()}`);
});

export function isDinoGede(a, b, c) {
  const key = normDinoWukuKey(a, b, c);
  return DINO_GEDE_SET.has(key);
}

export function isDinoIjo(a, b, c) {
  const key = normDinoWukuKey(a, b, c);
  return DINO_IJO_SET.has(key);
}

export function getDinoWarnaStatus(a, b, c, isMinggu = false, isLibur = false, code = '') {
  const key = normDinoWukuKey(a, b, c);
  const isIjo = DINO_IJO_SET.has(key);
  const isGede = DINO_GEDE_SET.has(key);

  const status = isIjo ? 'ijo' : 'abang';
  const bottomBg = isIjo ? '#15803d' : '#b91c1c'; // Hijau Solid vs Merah Solid (Kontras Tinggi WCAG AA)
  const bottomBgClass = isIjo ? 'bg-dino-ijo' : 'bg-dino-abang';
  const bottomTextColor = '#ffffff';

  const baseLabel = isIjo ? 'Dino Ijo / Becik' : 'Dina Ala / Kang Olo';
  const label = isGede ? `${baseLabel} · Dino Gede` : baseLabel;

  const cellBorder = isGede ? '#eab308' : (isIjo ? '#86efac' : '#fca5a5');
  const cellBorderStyle = isGede
    ? 'border: 2px solid #eab308; box-shadow: 0 0 10px rgba(234, 179, 8, 0.45);'
    : 'border: 1px solid #cbd5e1;';

  const alaSuffix = code ? `${code} Ala` : 'Ala';
  const baseBadgeText = isIjo ? '✓ Becik' : `▲ ${alaSuffix}`;
  const baseBadgeHtml = isIjo
    ? '<span class="inline-flex items-center px-1.5 py-0.5 rounded text-[8.5px] font-bold bg-[#15803d] text-white border border-[#166534] shadow-xs" title="Dina Ijo / Becik">✓ Becik</span>'
    : `<span class="inline-flex items-center px-1.5 py-0.5 rounded text-[8.5px] font-bold bg-[#b91c1c] text-white border border-[#991b1b] shadow-xs" title="${baseLabel}">▲ ${alaSuffix}</span>`;

  const gedeBadgeText = isGede ? '★ GEDE' : '';
  const gedeBadgeHtml = isGede
    ? '<span class="inline-flex items-center px-1.5 py-0.5 rounded text-[8.5px] font-extrabold bg-[#eab308] text-amber-950 border border-[#ca8a04] shadow-xs" title="Dino Gede">★ GEDE</span>'
    : '';

  const badgeText = isGede ? `${isIjo ? '✓ Becik' : `▲ ${alaSuffix}`} · ★ GEDE` : baseBadgeText;
  const badgeHtml = isGede ? `${gedeBadgeHtml} ${baseBadgeHtml}` : baseBadgeHtml;

  const cellBg = isIjo ? '#f0fdf4' : '#fef2f2';
  const cellText = isIjo ? '#14532d' : '#7f1d1d';

  return {
    isGede,
    isIjo,
    status,
    bottomBg,
    bottomBgClass,
    bottomTextColor,
    label,
    cellBg,
    cellBorder,
    cellBorderStyle,
    cellText,
    badgeText,
    badgeHtml,
    baseBadgeText,
    baseBadgeHtml,
    gedeBadgeText,
    gedeBadgeHtml
  };
}

export function evaluateDino(wuku, dino, pasaran) {
  const key = normDinoWukuKey(wuku, dino, pasaran);
  const isGede = DINO_GEDE_SET.has(key);
  const isIjo = DINO_IJO_SET.has(key);
  return {
    isGede,
    isIjo,
    isAbang: !isIjo,
    baseColor: isIjo ? 'green' : 'red'
  };
}

export function checkDinoGede(wukuId, d, pasaranId, hd, hm) {
  const cell = (GRID[wukuId] && GRID[wukuId][d]) ? GRID[wukuId][d] : ["", "G", 0];
  const code = cell[0] || "";
  const dinoName = HARI[d];
  const pasaranName = PASARAN[pasaranId];
  const wukuName = WUKU[wukuId];

  const normKey = (typeof normDinoWukuKey === 'function') 
    ? normDinoWukuKey(dinoName, pasaranName, wukuName)
    : `${String(dinoName).toLowerCase()}_${String(pasaranName).toLowerCase()}_${String(wukuName).toLowerCase().replace(/[\s\-_]/g, '')}`;
  
  const isCsvGede = (typeof DINO_GEDE_SET !== 'undefined' && DINO_GEDE_SET) ? DINO_GEDE_SET.has(normKey) : false;
  const isGridGede = Boolean(cell[2] === 1);
  const isTandaO = code.includes('O');
  const isAnggaraKasih = (d === 2 && pasaranId === 4) || isTandaO;
  const isJumatKliwon = (d === 5 && pasaranId === 4);
  const isSatuSura = (hd === 1 && hm === 1);

  // Sesuai mandat Two-Layer Logic: Dino Gede murni ditentukan oleh database_nujum - dino_gede.csv
  const isGede = isCsvGede;
  let label = isGede ? "Dino Gede" : "";
  if (isSatuSura) label = "1 Sura (Tahun Baru Jawa)";
  else if (isAnggaraKasih || isTandaO) label = "Anggara Kasih (Selasa Kliwon)";
  else if (isJumatKliwon) label = "Jumat Kliwon (Dina Sakral)";
  else if (isCsvGede) label = "Dino Gede";

  return { isGede, label, isGridGede, isTandaO, isAnggaraKasih, isJumatKliwon, isSatuSura, isCsvGede };
}

export const KETERANGAN_MAP = {
  "S": { nama: "Tangise Dewi Sinto", arti: "Dina tangise dewi, prayogi ngati-ati anggone mbudidaya utawa lelungan." },
  "O": { nama: "Anggoro Kasih", arti: "Selasa Kliwon, dina pangasihaning Gusti lan pasucen batin." },
  "W": { nama: "Tali Wangke", arti: "Sirikan ageng; awon kanggé wiwit adeg griya, mantu, utawa lelungan tebih." },
  "N": { nama: "Nuju Padu", arti: "Potensi congkrah / pasulayan; prayogi sabar lan ngedohi pradondi." },
  "Q": { nama: "Dino ora kanggonan tanggal", arti: "Dina lowong/wancak; prayogi boten kanggé hajat ageng." },
  "R": { nama: "Ringkel Jalma", arti: "Sirikan jalma manungsa; prayogi njagi kaselamatan raga." },
  "K": { nama: "Kala Dite", arti: "Kala ing dina Ngahad; prayogi ngati-ati tumrap godha." },
  "T": { nama: "Kala Tinantang", arti: "Kala nantang; watak wanton, prayogi mengker hawa nepsu." },
  "P": { nama: "Nuju Pati", arti: "Sirikan ageng tumrap lelakon anyar utawa bebadan usaha." },
  "D": { nama: "Dungulan", arti: "Watak unggul nanging prayogi ngatos-atos ing tindak-tanduk." },
  "A": { nama: "Sampar Wangke", arti: "Sirikan ageng; prayogi boten kanggé pawiwahan utawa pindah griya." },
  "X": { nama: "Sarik Agung", arti: "Sarik / larangan ageng; prayogi ngedohi hajat wigati." }
};

export function getKeteranganKodeDetail(code) {
  if (!code) return [];
  const list = [];
  for (let ch of code) {
    if (KETERANGAN_MAP[ch]) {
      list.push(KETERANGAN_MAP[ch]);
    }
  }
  return list;
}

if (typeof window !== 'undefined') {
  window.HARI = HARI;
  window.NEPTU_HARI = NEPTU_HARI;
  window.PASARAN = PASARAN;
  window.NEPTU_PASARAN = NEPTU_PASARAN;
  window.BULAN_MASEHI = BULAN_MASEHI;
  window.BULAN_JAWA = BULAN_JAWA;
  window.WINDU = WINDU;
  window.WUKU = WUKU;
  window.DUNUNGE = DUNUNGE;
  window.GRID = GRID;
  window.KETERANGAN = KETERANGAN;
  window.toJDN = toJDN;
  window.jdnToIslamic = jdnToIslamic;
  window.getDayInfo = getDayInfo;
  window.getTanggalJawaLengkap = getTanggalJawaLengkap;
  window.LIBUR_NASIONAL = LIBUR_NASIONAL;
  window.getLiburNasional = getLiburNasional;
  window.checkDinoGede = checkDinoGede;
  window.KETERANGAN_MAP = KETERANGAN_MAP;
  window.getKeteranganKodeDetail = getKeteranganKodeDetail;
  window.DINO_GEDE_LIST = DINO_GEDE_LIST;
  window.DINO_IJO_LIST = DINO_IJO_LIST;
  window.normDinoWukuKey = normDinoWukuKey;
  window.DINO_GEDE_SET = DINO_GEDE_SET;
  window.DINO_IJO_SET = DINO_IJO_SET;
  window.isDinoGede = isDinoGede;
  window.isDinoIjo = isDinoIjo;
  window.getDinoWarnaStatus = getDinoWarnaStatus;
  window.evaluateDino = evaluateDino;
}
if (typeof module !== 'undefined' && module.exports) {
  module.exports.HARI = HARI;
  module.exports.NEPTU_HARI = NEPTU_HARI;
  module.exports.PASARAN = PASARAN;
  module.exports.NEPTU_PASARAN = NEPTU_PASARAN;
  module.exports.BULAN_MASEHI = BULAN_MASEHI;
  module.exports.BULAN_JAWA = BULAN_JAWA;
  module.exports.WINDU = WINDU;
  module.exports.WUKU = WUKU;
  module.exports.DUNUNGE = DUNUNGE;
  module.exports.GRID = GRID;
  module.exports.KETERANGAN = KETERANGAN;
  module.exports.toJDN = toJDN;
  module.exports.jdnToIslamic = jdnToIslamic;
  module.exports.getDayInfo = getDayInfo;
  module.exports.getTanggalJawaLengkap = getTanggalJawaLengkap;
  module.exports.LIBUR_NASIONAL = LIBUR_NASIONAL;
  module.exports.getLiburNasional = getLiburNasional;
  module.exports.checkDinoGede = checkDinoGede;
  module.exports.KETERANGAN_MAP = KETERANGAN_MAP;
  module.exports.getKeteranganKodeDetail = getKeteranganKodeDetail;
  module.exports.DINO_GEDE_LIST = DINO_GEDE_LIST;
  module.exports.DINO_IJO_LIST = DINO_IJO_LIST;
  module.exports.normDinoWukuKey = normDinoWukuKey;
  module.exports.DINO_GEDE_SET = DINO_GEDE_SET;
  module.exports.DINO_IJO_SET = DINO_IJO_SET;
  module.exports.isDinoGede = isDinoGede;
  module.exports.isDinoIjo = isDinoIjo;
  module.exports.getDinoWarnaStatus = getDinoWarnaStatus;
  module.exports.evaluateDino = evaluateDino;
}


